/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Workflows/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaIconAccountTree from 'DesignSystem/Svgs/TysiaIconAccountTree/index'



/** @type {import('Simple/types.js').View} */
export default function Workflows({
  children,
  viewPath = "/App/Account/Topbar/Tabs/More/Content/Tabs/Tab/Icon/Workflows",
  hovered,
  selected
  
}) {
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsGreen600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.green.600'
        })
  return (<React.Fragment
>
<TysiaIconAccountTree
  viewPath={`${viewPath}/TysiaIconAccountTree`}
 width={16}
 height={16}
 fill={hovered && selected ? dtColorsGreen600 : hovered ? dtColorsWhite : selected ? dtColorsGreen600 : dtColorsWhite}
/>
{children}
</React.Fragment>)
}